import { enum_EDPPREPARE_FORM_MODE } from "../../common/Dictionaries";
import { 
	SET_FIRST_LOAD,
	SET_EDP_PREPARE_ERROR_VALIDATIONS,
	SET_EDP_PREPARE_RESULT,
	SET_EDP_PREPARE_PARTIES,
	SET_EDP_PREPARE_DI,
	SET_FORM_MODE,
	SET_EDP_PREPARE_AMBIENTE,
	SET_EDP_PREPARE_HEADER,
	SET_EDP_PREPARE_MANAGE_BUTTONS,
	SET_EDP_PREPARE_FORCE_GET_RESULT,
	SET_EDP_PREPARE_FORCE_GET_PARTIES,
	SET_EDP_PREPARE_FORCE_GET_AMBIENTE,
	SET_EDP_PREPARE_FORCE_GET_HEADER,
	SET_EDP_PREPARE_FORCE_GET_BUTTONS
} from "../actions/PAY/edpPrepareActions";

const initialState = {
	_formMode: enum_EDPPREPARE_FORM_MODE.CREATE,
	_firsLoadResult: null,
	_firsLoadParties: null,
	_firsLoadDI: null,
	_edpPrepareResult: null,
	_edpPrepareParties: null,
	_edpPrepareDIs: null,
	_edpPrepareErrorValidations: null,
	_edpPrepareAmbiente: null,
	_edpPrepareHeader: null,
	_edpPrepareManageButtons: {
		filled: false,
		btnEliminarRevisionVisible: false,
		btnAnularRevisionVisible: false,
		btnEnviarRevisionVisible: false,
		btnTerminarRevisionVisible: false,
		tblhtmlAprobarVisible: false,
		tblhtmlRevisionDinamicaVisible: false,
		btnIngresarDatosEPVisible: false,
	},
	_forceGet_PrepareResult: false,
	_forceGet_PrepareParties: false,
	_forceGet_PrepareAmbiente: false,
	_forceGet_PrepareHeader: false,
	_forceGet_PrepareManageButtons: false,
};

const edpConfigReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_FORM_MODE:
			return {
				...state,
				_formMode: action.payload
			};

		case SET_FIRST_LOAD:
			return {
				...state,
				[action.payload.type]: action.payload.flag
			};

		case SET_EDP_PREPARE_ERROR_VALIDATIONS:
			return {
				...state,
				_edpPrepareErrorValidations: action.payload,
			};

		case SET_EDP_PREPARE_RESULT:
			return {
				...state,
				_edpPrepareResult: action.payload,
			};
		
		case SET_EDP_PREPARE_PARTIES:
			return {
				...state,
				_edpPrepareParties: action.payload,
			};

		case SET_EDP_PREPARE_DI:
			return {
				...state,
				_edpPrepareDIs: action.payload,
			};

		case SET_EDP_PREPARE_AMBIENTE:
			return {
				...state,
				_edpPrepareAmbiente: action.payload,
			};
			
		case SET_EDP_PREPARE_HEADER:
			return {
				...state,
				_edpPrepareHeader: action.payload,
			};	
		case SET_EDP_PREPARE_MANAGE_BUTTONS:
			return {
				...state,
				_edpPrepareManageButtons: action.payload,
			}

		case SET_EDP_PREPARE_FORCE_GET_RESULT:
			return {
				...state,
				_forceGet_PrepareResult: action.payload,
			}
		case SET_EDP_PREPARE_FORCE_GET_PARTIES:
			return {
				...state,
				_forceGet_PrepareParties: action.payload,
			}
		case SET_EDP_PREPARE_FORCE_GET_AMBIENTE:
			return {
				...state,
				_forceGet_PrepareAmbiente: action.payload,
			}

		case SET_EDP_PREPARE_FORCE_GET_HEADER:
			return {
				...state,
				_forceGet_PrepareHeader: action.payload,
			}

		case SET_EDP_PREPARE_FORCE_GET_BUTTONS:
			return {
				...state,
				_forceGet_PrepareManageButtons: action.payload,
			}
		default:
			return state;
	}
};



export default edpConfigReducer;